/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for Teams oral exam transcript-or-unwind job.

Covers never-started bookings (no-show list) and started-but-no-VTT bookings
(event-completion list). After grace: imported VTT may complete; else unwind
with teams_no_transcript without incrementing attempt_number.
 */
export interface MeetingsTeamsOralUnwindParams {
  marginHours?: number;
  graceMinutes?: number;
  forceGraceMinutes?: number;
  statuses?: string[];
}
